import { useQuery } from '@tanstack/react-query'
import {
  type CourseRulesDraft,
  getCourseRequirements,
  getCourseRules,
  REGULAR_CREDIT_TYPE,
} from '@/lib/credits-api'

export const emptyCourseRulesDraft: CourseRulesDraft = {
  credit_type_id: REGULAR_CREDIT_TYPE,
  requires_approval: false,
  max_guests_per_booking: 0,
  requires_terms: false,
  terms_body: '',
}

/** Loads the saved rules and current terms text of a course; new courses start with defaults. */
export function useCourseRulesDraft(courseId: string | null): CourseRulesDraft | null {
  const rules = useQuery({
    queryKey: ['course-rules'],
    queryFn: getCourseRules,
    enabled: courseId !== null,
  })
  const terms = useQuery({
    queryKey: ['course-requirements', courseId],
    queryFn: () => getCourseRequirements({ courseId: courseId! }),
    enabled: courseId !== null,
  })
  if (courseId === null) return emptyCourseRulesDraft
  const course = rules.data?.find((entry) => entry.id === courseId)
  // Both queries refetch independently; only use them once their terms versions match.
  if (
    !course || !terms.data ||
    course.current_terms_version_id !== terms.data.terms_version_id
  ) return null
  return {
    credit_type_id: course.credit_type_id,
    requires_approval: course.requires_approval,
    max_guests_per_booking: course.max_guests_per_booking,
    requires_terms: course.requires_terms,
    terms_body: terms.data.terms_body ?? '',
  }
}
